import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type {
  PollsterApiDTO,
  ProjectApiDTO,
} from '@testsa-com/common/src/codegen/generated/Api.schemas'

type ChatStoreType = {
  isChatOpened: boolean
  pollsterId?: PollsterApiDTO['id']
  projectId?: ProjectApiDTO['id']
}

const CHAT_KEY = 'tsa-chat'

export const useChatStore = create(
  persist<ChatStoreType>(
    () => ({
      isChatOpened: false,
      pollsterId: undefined,
      projectId: undefined,
    }),
    { name: CHAT_KEY },
  ),
)
